import { render, staticRenderFns } from "./disciplines.vue?vue&type=template&id=5f6769fd&scoped=true&"
import script from "./disciplines.ts?vue&type=script&lang=ts&"
export * from "./disciplines.ts?vue&type=script&lang=ts&"
import style0 from "./disciplines.scss?vue&type=style&index=0&id=5f6769fd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f6769fd",
  null
  
)

export default component.exports